<template>
  <v-container fluid class="catalog-page">
    <v-row>
      <Search name="items">
        <Additional catalog="items" />
        <Print catalog="items" />
      </Search>
    </v-row>
    <v-row>
      <v-col v-if="catPermissions" cols="12" lg="3" md="3" sm="12" xs="12" class="cats-col">
        <v-row>
          <Categories catalog="items" />
        </v-row>
      </v-col>
      <v-col cols="12" :lg="(catPermissions ? 9 : 12)" :md="(catPermissions ? 9 : 12)" sm="12" xs="12" class="list-col">
        <List />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/templates/global/Search'
import Additional from '../additional/Dialog'
import Print from './templates/Print'
import Categories from '../categories/Categories'
import List from './templates/List'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Search, Additional, Print, Categories, List },
  mixins: [ appdata, utils ],
  computed: {
    catPermissions: function () {
      return (typeof this.permissions.catalog.categories !== 'undefined' && this.permissions.catalog.categories)
    }
  }
}
</script>

<style src="../styles/index.scss" lang="scss"></style>
